import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'components/input/SelectField/SelectField';

const BooleanFilter = ({ label, source, ...restProps }) => {
    return (
        <SelectField
            label={ label }
            source={ source }
            fullWidth={ true }
            floatingLabelFixed={ true }
            choices={ [
                {
                    id: '1',
                    name: `filters.components.${ source || 'enabled' }.choices.active`,
                },
                {
                    id: '0',
                    name: `filters.components.${ source || 'enabled' }.choices.inactive`,
                },
            ] }
            { ...restProps }
        />
    );
};

BooleanFilter.propTypes = {
    label: PropTypes.string,
    source: PropTypes.string.isRequired,
};

export default BooleanFilter;


// WEBPACK FOOTER //
// ./src/components/form/filters/BooleanFilter.js